import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Typography,
  Button,
  TextField,
  Autocomplete,
  Chip,
  IconButton,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";

export const SettingsDialog = ({
  open,
  onClose,
  selectedFolder,
  selectedProjects,
  onProjectsChange,
  customers,
  onSave,
  displayName,
  onDisplayNameChange,
}: any) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: { borderRadius: 0 },
      }}
    >
      <DialogTitle>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h6">{selectedFolder?.name}/Settings</Typography>
          <IconButton onClick={onClose} edge="end">
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        {selectedFolder && (
          <Box sx={{ display: "flex", flexDirection: "column", gap: 3, pt: 1 }}>
            {/* Display Name */}
            <Box>
              <Typography variant="subtitle1" gutterBottom>
                Display Name
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                Set a custom display name for this folder. If left empty, the
                original folder name will be used.
              </Typography>
              <TextField
                label="Display Name"
                placeholder="Enter custom display name"
                value={displayName || ""}
                onChange={(e) => onDisplayNameChange(e.target.value)}
                fullWidth
                size="small"
              />
            </Box>

            {/* Projects Selection */}
            <Box>
              <Typography variant="subtitle1" gutterBottom>
                Associated Projects
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                Select projects to associate with this folder. This will help
                organize and track project-related files.
              </Typography>

              <Autocomplete
                multiple
                options={customers || []}
                getOptionLabel={(option) =>
                  option.name || option.project_name || `Project ${option.id}`
                }
                size="small"
                value={selectedProjects}
                onChange={onProjectsChange}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Projects"
                    placeholder="Choose projects to associate with this folder"
                    fullWidth
                  />
                )}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => (
                    <Chip
                      variant="outlined"
                      label={
                        option.name ||
                        option.project_name ||
                        `Project ${option.id}`
                      }
                      {...getTagProps({ index })}
                      key={option.id || option._id}
                    />
                  ))
                }
              />
            </Box>
          </Box>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} color="inherit">
          Cancel
        </Button>
        <Button onClick={onSave} variant="contained">
          Save Settings
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SettingsDialog;
